<template>
  <div class="content">
    <div class="steps-box">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>

    <div class="second-title" v-if="current == 0">
      <span style="font-size:20px;font-weight: 600; color: black;">填写预约信息 </span>
      <span>(以下必填项，如无身份证，请直接拨打87810788联系我处)</span>
    </div>
    <div class="second-title" v-if="current == 1">
      <span style="font-size:20px;font-weight: 600; color: black;">选择预约时间 </span>
      <span>(以下必填项，如无身份证，请直接拨打87810788联系我处)</span>
    </div>
    <div class="second-title" v-if="current == 2">
      <span style="font-size:20px;font-weight: 600; color: black;">预约回执 </span>
      <span>地址：福州市鼓楼区华林路97号一楼签证服务部(山海大厦华林路一侧，招商银行旁边) 咨询电话：87810788 87811482</span>
    </div>

    <div class="steps-content">
      <!-- 填写预约信息 -->
      <div v-if="current == 0">
        <a-form :form="form">
          <div class="flexline">
            <!-- 选择器表单 -->
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="签证类型">
              <a-select v-decorator="[ 'visaType', { rules: [{ required: true, message: '请选择签证类型!' }] },]" placeholder="请选择签证类型" @change="selectType">
                <a-select-option v-for="d in qzlxdata" :key="d.DICT_VALUE">
                  {{ d.DICT_VALUE_NAME }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item class="aaaform" :label-col="selectItemLayout.labelCol" :wrapper-col="selectItemLayout.wrapperCol" :label="leibie + ':'" v-if="qztype !== ''">
              <a-select v-decorator="['stayType',{ rules: [{ required: true, message: '请选择'+leibie+'!' }] },]" :placeholder="'请选择'+leibie" @change="visitiType">
                <a-select-option v-for="d in visitidata" :key="d.DICT_VALUE">
                  {{ d.DICT_VALUE_NAME }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <!-- 正常表单 -->
          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名">
              <a-input v-decorator="[
          'name',
          { rules: [{ required: true, message: '请输入合法姓名'}] },
        ]" placeholder="请输入姓名" />
            </a-form-item>
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="身份证号码">
              <a-input v-decorator="[
          'idCard',
        ]" placeholder="请输入身份证号码" />
            </a-form-item>
          </div>

          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="联系手机号码">
              <a-input v-decorator="[
          'mobilePhone',
          { rules: [{ required: true, message: '请输入合法的手机号码' ,pattern: /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|19[0-9]|18[0-9]|14[0-9])[0-9]{8}$/}] },
        ]" placeholder="请输入联系手机号码" />
            </a-form-item>
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="护照号">
              <a-input v-decorator="[
          'passportId',
          { rules: [{ required: true, message: '请输入护照号'}] },
        ]" placeholder="请输入护照号" />
            </a-form-item>
          </div>
        </a-form>

      </div>
      <div v-if="current == 1">
        <div class="flexline">
          <div style="width:50%">
            <span>预约日期:</span>
            <a-select style="width:200px;" @change="dateSelect">
              <a-select-option v-for="d in attentionDate" :key="d.value">
                {{ d.name }}
              </a-select-option>
            </a-select>
          </div>

          <div>
            <span>预约时间:</span>
            <a-select style="width:200px;" @change="timeSelect">
              <a-select-option v-for="d in attentionTime" :key="d.value">
                {{ d.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div v-if="current == 2">
        <div class="content-box" id="maindiv">
          <div style="margin: 0 1.9cm;width: 80%;">

            <div style="font-weight:600;color: black;text-align:center;font-size:30px;margin: 70px 0;">日本签证预约回执单</div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;word-spacing: 4px;">预 约 号:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.reserve_id}}</div>
            </div>
            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;letter-spacing: 0px;">预约时间:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.reserve_date}}&nbsp; {{orderInfo.time_range}}</div>
            </div>
            <div class="line1">
              <div style="font-weight:600;font-size:18px; color: black;word-spacing:30px;">姓 名:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.name}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;;word-spacing: 4px;">护 照 号:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.passport_id}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;">签证类别:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.visa_type}}</div>
            </div>

            <div class="line1">
              <div style="font-weight:600;font-size:18px;color: black;">联系电话:</div>
              <div style="border-bottom: 1px solid black;width: 300px;text-indent:20px">{{orderInfo.mobile_phone}}</div>
            </div>
            <div class="line">
              <span style="font-weight:600;font-size:18px;color: black;">备注:</span>
              <div class="beizhu">
                <div>
                  <div>1、请申请人凭此预约单及签证所需材料，按预约时间进入日本签证受理大厅办理签证。</div>
                  <div>2、此预约单上的预约号不是签证受理顺序号，申请人到达受理大厅按排队顺序获取签证受理号。</div>
                </div>
                <div>
                  3、签证所需材料及表格下载请参考网址：
                  <div>
                    <a href="http://www.ffasc.cn/templates/template2/4/page.ftl?LXBS=CJQZ_RBQZ_PRGLQZZXCL&sjlxbs=CJQZ&LXID=47" target="_blank">http://www.ffasc.cn/templates/template2/4/page.ftl?LXBS=CJQZ_RBQZ_PRGLQZZXCL&sjlxbs=CJQZ&LXID=47</a>
                  </div>
                </div>
                <div style="font-weight:bold">
                  请务必准备好所需材料，填好信息表等表格，否则将会影响您在现场的办理速度
                </div>
                <div>
                  4、签证受理流程：
                  <div style="margin-top:10px">
                    <img src="@/assets/process.png" alt="" style="width: 98%;margin-left: 1px;">
                  </div>
                </div>
                <div>
                  地址：福州市鼓楼区华林路97号一楼签证服务部（山海大厦华林路一侧，招商银行旁边）
                </div>
                <div>
                  咨询电话：87810788  87811482
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps-action">
      <a-button v-if="current == 0" type="primary" @click="next">选择预约时间</a-button>
      <a-button v-if="current == 1" type="primary" @click="quedingyuyue">确定预约</a-button>
      <a-button v-if="current == 2" type="primary" @click="print">
        打印回执
      </a-button>
      <!-- <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">上一步</a-button> -->
    </div>
    <div v-if="current == 0">
      <!-- 注意事项标题 -->
      <div class="title">
        <div v-for="item in attentionList" :key="item" class="tab-box" @mouseenter="changeTarget(item)" :style="
            target === item
              ? 'color: #000000; border-bottom: 2px solid rgba(203, 180, 134, 1);'
              : ''
          ">
          <span>{{ item }}</span>
        </div>
      </div>
      <!-- 预约须知内容 -->
      <div class="attention-info" v-show="target == '预约须知'">
        <p style="font-size: 16px;color: black;font-weight: 600;">关于启用日本签证受理网上预约系统的通知</p>
        <div>
          为保证赴日签证受理工作的正常有序进行，我中心已启用赴日签证受理网上预约系统。前来办理探亲、商务、居留签证的申请人请提前登录我中心网站www.ffasc.cn“日本签证网上预约”系统，预约签证办理时间，填写所需表格。
        </div>
        <!-- <div>
          持有《在留资格认定证明书》的签证申请人请事先下载打印问答卷(<a class="gold-font" href="https:/www.guangzhou.cn.emb-japan.go,jp/cgip_cn/visa/doclvi-sa0005.html" target="_blank">https:/www.guangzhou.cn.emb-japan.go,jp/cgip_cn/visa/doclvi-sa0005.html</a>)，认真填写表格中每个栏目信息后再进行预约，未填写完整者不能按预约时间受理。在疫情防控期间，请已预约的申请人凭当日预约单和“健康码”,“通信大数据行程卡”进入日本签证受理大厅办理签证。
        </div> -->
        <div>
          持有《在留资格认定证明书》的签证申请人请事先下载打印<a class="gold-font" href="http://www.ffasc.cn/#/announcement?type=contentAnnounce&moduleCode=RESB07757FD334EBBF&name=%E9%97%AE%E7%AD%94%E5%8D%B7&linkname=%E5%87%BA%E5%9B%BD%E7%AD%BE%E8%AF%81%2F%E8%A1%A8%E6%A0%BC%E4%B8%8B%E8%BD%BD%2F%E9%97%AE%E7%AD%94%E5%8D%B7%2F%E8%AF%A6%E6%83%85">问答卷</a>，认真填写表格中每个栏目信息后再进行预约，未填写完整者不能按预约时间受理。
        </div>
      </div>
      <!-- 注意事项内容 -->
      <div class="attention-info" v-show="target == '注意事项'">
        <div>
          1.预约成功后，若不能如期前往办事大厅办理签证，请于预约日期前一晚上12:00之前取消预约，否则算作违规。
        </div>
        <div>
          2.如果您在最近1个月内有两次违规记录，将无法进行网上预约，请致电0591-87810788。
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};

const selectItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};
import { getQZLXList, getTQLBList, getAttentionDate, getAttentionTime, reserveOrder, getdetail } from "@/api/goaborad";
import { printHtml } from "@/util/exportPdf.js";
export default {

  name: "hover-box",
  data () {
    return {
      current: 0,
      steps: [ //步骤
        {
          title: '填写预约信息',
          content: 'First-content',
        },
        {
          title: '选择预约时间',
          content: 'Second-content',
        },
        {
          title: '打印预约回执',
          content: 'Last-content',
        },
      ],
      attentionList: ['预约须知', '注意事项'],
      target: '预约须知',
      checkNick: false,
      formItemLayout,
      selectItemLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      qzlxdata: [],
      qztype: '',
      visitidata: [],
      nextStep: 'no',
      attentionDate: [],
      attentionTime: [],
      orderInfo: {
        id_card: '',
        name: '',
        mobile_phone: '',
        passport_id: '',
        reserve_date: '',
        time_range: '',
        timeRange: '',
        reserveDate: ''
      },
      leibie: ''
    };
  },
  created () {
    this.getQZLXList()
    this.getReserveConfig()
  },
  methods: {
    getQZLXList () {  //获取签证类型列表
      getQZLXList().then((res) => {
        this.qzlxdata = res.data
      })
    },
    getTQLBList (value) {  //获取弹琴类别列表
      getTQLBList(value).then((res) => {
        this.visitidata = res.data
      })
    },
    next () {  //下一步
      console.log('assa',);
      if (this.current == 0) {
        this.check()
      }
      if (this.nextStep !== 'ok') {
        return
      }
      if (this.current++ > 2)
        this.active = 0;
      this.nextStep = 'no'
    },
    quedingyuyue () {
      this.reserveOrder()
    },
    prev () {  //上一步
      this.current--;
    },
    selectType (value) { //签证类别
      this.qztype = value;
      this.getTQLBList(value)
      if (value == 0) {
        this.leibie = '探亲类别'
      } else if (value == 1) {
        this.leibie = '在留类别'
      } else if (value == 2) {
        this.leibie = '赴日情况'
      }

    },
    visitiType (value) {  //探亲类别
      console.log('类别', value);
    },
    check () {  //表单提交 选择
      this.form.validateFields((err, values) => {
        this.orderInfo = values
        if (!err) {
          this.nextStep = 'ok'
        }
      });
    },
    handleChange (e) {  //
      this.checkNick = e.target.checked;
      this.$nextTick(() => {
        this.form.validateFields(['nickname'], { force: true });
      });
    },
    changeTarget (item) {  //注意事项切换
      this.target = item;
    },
    getReserveConfig () {  //预约时间
      getAttentionDate().then((res) => {
        this.attentionDate = res.data
      })
    },
    getAttentionTime (value) {
      getAttentionTime(value).then((res) => {
        this.attentionTime = res.data
      })
    },
    dateSelect (value) {
      console.log('dateSelect', value);
      this.orderInfo.reserveDate = value
      this.getAttentionTime(value)
    },
    timeSelect (value) {
      console.log(value);
      this.orderInfo.timeRange = value
      this.nextStep = 'ok'
    },
    print () {
      let dom = document.querySelector("#maindiv").innerHTML;
      printHtml(dom);
    },
    reserveOrder () {  //确定预约
      console.log(this.orderInfo);
      if (this.orderInfo.reserveDate == '' || this.orderInfo.timeRange == '') {
        alert('请选择时间')
        return
      }
      reserveOrder(this.orderInfo).then((res) => {
        if (res.code == 200) {
          this.orderInfo = res.data
          this.current = 2
        } else {
          this.current = 1
          this.$message.error(res.message);
        }
      })
    },
  }
};
</script>


<style lang="less" scoped>
.content {
  // text-align: center;
  padding-top: 20px;
  font-family: Microsoft YaHei;
  // width: 800px;
}

.steps-box {
  margin: 0 auto;
  // display: flex !important;
  // justify-content: center;
}
/deep/.ant-steps .ant-steps-item-container {
  width: 200px;
}

/deep/.ant-steps .ant-steps-item {
  width: 200px;
}
/deep/.ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  color: goldenrod;
}
/deep/.ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  color: goldenrod;
}

/deep/.ant-steps-item-process .ant-steps-item-icon {
  background: goldenrod;
  border: background;
}
/deep/.ant-steps-item-title::after {
  background: goldenrod;
  height: 2px;
}
/deep/.ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title::after {
  background-color: goldenrod;
}

/deep/.ant-steps-item-finish .ant-steps-item-icon {
  color: goldenrod;
}
/deep/.ant-steps-item-finish .ant-steps-item-icon {
  color: goldenrod;
}
/deep/.ant-steps-item-finish .ant-steps-item-icon {
  border-color: goldenrod;
}
/deep/.ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title::after {
  background-color: goldenrod;
}
/deep/.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: goldenrod;
}
.ant-steps-item {
  width: 50%;
}
.second-title {
  margin: 20px 0;
  text-align: left;
  color: rgb(198, 200, 199);
}
.steps-content {
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: rgb(250, 251, 251);
  // min-height: 330px;
  text-align: center;
  padding: 30px 0;
}

.steps-action {
  margin-top: 24px;
}

[data-theme="dark"] .steps-content {
  background-color: #2f2f2f;
  border: 1px dashed #404040;
}
.attention-info {
  text-align: left;
  margin: 20px 30px 0 0;
  line-height: 40px;
  text-align: justify;
  text-justify: inter-ideograph;
  font-size: 16px;
}

.flexline {
  display: flex;
}
.flexline .ant-row {
  width: 50%;
}

/deep/.ant-form-item-children {
  display: flex;
}

/deep/.ant-form-explain {
  text-align: left;
}

.title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: left;
  color: rgb(198, 200, 199);
}
.tab-box:nth-child(2) {
  margin: 0 20px;
  // border-bottom: 2px solid rgb(203, 180, 134);
}
.tab-box:hover {
  cursor: pointer;
}

.content-box {
  width: 85%;
  text-align: left;
}
.line {
  margin-top: 20px;
  font-size: 17px;
}
.line1 {
  margin-top: 20px;
  font-size: 17px;
  display: flex;
}
.beizhu {
  margin-left: 50px;
  margin-top: -33px;
  line-height: 40px;
}

.ant-btn-primary {
  background-color: #cbb486 !important;
  border-color: #cbb486 !important;
}
.gold-font {
  color: #cbb486;
}
</style>


// WEBPACK FOOTER //
// src/components/home/specialServiceInformation/components/content-01.vue